// SidebarSwitcher.jsx

import React from 'react';

// Context
import { useUI } from 'context/UIContext';

// Hooks
import useBaseSwitcher from 'hooks/useBaseSwitcher';

// CSS
import './SidebarSwitcher.css';

// Components
import SwitcherToggle from 'main/sidebar/switcher/toggle/SwitcherToggle';
import BaseAddModal from 'bases/add/BaseAddModal';

/**
 * SidebarSwitcher
 *
 * Allows the user to switch between bases in the desktop sidebar.
 *
 * @returns {ReactNode} - SidebarSwitcher.
 */
const SidebarSwitcher = React.memo(() => {
    // ----- CONTEXT ----- //

    const { isSidebarRailCompact } = useUI();
    const compact = Boolean(isSidebarRailCompact);

    // ----- HOOKS ----- //

    const {
        activeBaseKey,
        addOpen,
        handleBaseAdd,
        handleBaseSelect,
        setAddOpen,
        user,
        bases,
    } = useBaseSwitcher();

    // ----- HANDLERS ----- //

    /**
 * Handles toggle click.
 */

    const handleToggleClick = () => {};

    if (!user) return null;

    // ----- RENDER ----- //

    return (
        <div
          className={[
            'sidebar-switcher-container',
            compact ? 'is-rail-compact' : '',
          ].filter(Boolean).join(' ')}
        >
            <SwitcherToggle
              bases={bases}
              activeBaseKey={activeBaseKey || null}
              onClick={handleToggleClick}
              onBaseAdd={handleBaseAdd}
              onBaseSelect={handleBaseSelect}
            />

            <BaseAddModal
              isOpen={addOpen}
              setOpen={setAddOpen}
              onSave={(base) => {
                    if (base?.key) {
                        handleBaseSelect(base);
                    }
                }}
            />
        </div>
    );
});

// Dev Tools
SidebarSwitcher.displayName = 'SidebarSwitcher';

export default SidebarSwitcher;
